import { GET_WELLNESSPLAN_BY_USER_AND_PET } from "../wellness-plan/wellness-plan-by-petId.query";
import { IUpdateSubscriptionPaymentMethodResponse } from "./update-Subscription-PaymentMethod.interface";
import { UPDATE_SUBSCRIPTION_PAYMENT_METHOD } from "./update-Subscription-PaymentMethod.mutation";
import { useMutation } from "@apollo/client";
import { useSearchParams } from "react-router-dom";
import { useWellnessPlanRecord } from "../../hooks";

export const useUpdateSubscriptionPaymentMethod = () => {
  const { wellnessPlanRecord: { wellnessPlanDetails } } = useWellnessPlanRecord();
  const [searchParams] = useSearchParams();
  const petId = searchParams.get("id");
  const [updateSubscriptionPaymentMethod, { data, loading, error }] =
     useMutation<{updateSubscriptionPaymentMethod:
         IUpdateSubscriptionPaymentMethodResponse}>(UPDATE_SUBSCRIPTION_PAYMENT_METHOD);

  const updateSubscriptionPayment = (wellnessId: string, cardId: string) => {
    updateSubscriptionPaymentMethod({
      variables: {
        wellnessId,
        cardId,
      },
      refetchQueries: [{
        query: GET_WELLNESSPLAN_BY_USER_AND_PET,
        variables: { petId: wellnessPlanDetails?.animal_id || petId },
      }],
    });
  };

  return {
    updateSubscriptionPayment,
    response: data?.updateSubscriptionPaymentMethod,
    loading,
    error,
  };
};
